import { eventActions } from "../../actionTypes";

const initialState = {
	formats: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case eventActions.FETCH_EVENT_FORMATS: {
			return { ...state, fetching: true };
		}

		case eventActions.FETCH_EVENT_FORMATS_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				formats: action.payload.data,
			};
		}

		case eventActions.FETCH_EVENT_FORMATS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
